import React, {useState, useEffect} from "react";
import {Routes, Route, useNavigate,useLocation,Link} from 'react-router-dom';
import moment from 'moment';
import {  Table, Select, DatePicker, Spin, Input, Typography, Tooltip } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';

import * as Styled from './style.js';
import { postData,getData } from '../../config/api-connect';
import Spinner from '../../components/spinner'
import PercentageBadge from '../../components/percentageBadge'

const { Option } = Select;
const { TextArea } = Input;

const Attendance = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const page = queryParams.get('page');
  var local_city = JSON.parse(localStorage.getItem('cityId'))
  var local_selectedVenueId = JSON.parse(localStorage.getItem('selectedVenueId'))
  if(!local_selectedVenueId){
    local_selectedVenueId = 'All'
  }

  var local_game_type = JSON.parse(localStorage.getItem('gameType'))
  if(!local_game_type){
    local_game_type = 8
  }

  const [loading, setLoading] = useState(true)
  const [venues, setVenues] = useState([])
  const [cities, setCities] = useState([])
  const [cityId, setCityId] = useState(local_city)
  const [gameType, setGameType] = useState(local_game_type)
  const [gameLevel, setGameLevel] = useState('')
  const [venuelist, setVenuelist] = useState([])
  const [selectedVenueId, setSelectedVenueId] = useState(local_selectedVenueId)
  const [batchesData, setBatchesData] = useState([])
  const [ageGroups, setAgeGroups] = useState([])
  const [ageGroupId, setageGroupId] = useState('')

  useEffect(() => {
    localStorage.setItem('selectedVenueId',JSON.stringify(selectedVenueId))
    localStorage.setItem('cityId',JSON.stringify(cityId))
    localStorage.setItem('gameType',JSON.stringify(gameType))
  }, [selectedVenueId,cityId,gameType]);

  useEffect(() => {
     getVenues()
  }, []); 

  useEffect(() => {
    if(cityId !== ''){
      setLoading(true)
      setBatchesData([])
      getBatchDetails()
    }
  }, [selectedVenueId,cityId,gameType,gameLevel,ageGroupId,page]); 

  useEffect(() => {
    if(cities.length){
      getVenuesInCity()
    }
  }, [cities,cityId]);

  const handleCityChange = (value) => {
    if (value.length > 0) {
      const last_selected = value[value.length - 1]
      if(last_selected == 'All'){
        setCityId(['All']);
      }
      else{
        const filtered = value.filter(v => v !== 'All');
        setCityId(filtered)
      }
    }
    else {
      setCityId(['All']);
    }
  };

  const getVenuesInCity =() =>{
    if(cities[0] && !cityId){
      setCityId([cities[0].id])
    }

    let filteredVenues;

    if (cityId === 'All' || (Array.isArray(cityId) && cityId.includes('All')) ) {
      filteredVenues = venues;
    } else {
      filteredVenues = Array.isArray(cityId) ? venues.filter(item => cityId.includes(item.city)) : venues ;
    }

    setVenuelist(filteredVenues);
    const venueExists = filteredVenues.some(item => item.id === selectedVenueId);
    if (!venueExists) {
      setSelectedVenueId('All');
    }
  }

  const getVenues = async () => {
    await getData('/business/get_venues_for_buddies/')
    .then(response =>{
      setVenues(response.result)
      setCities(response.cities)
      setAgeGroups(response.age_groups)
    })
    .catch(error => {
      console.log(error.message);
    });
  }

  const getBatchDetails = () => {
    let url = `/business/get_attendance_summary/?`
    if (page === 'summary') {
      url = `/business/get_customers_attendence_summary/?`
    }
    url += `venue_id=${selectedVenueId}&city_id=${cityId}&game_type_id=${gameType}&game_level=${gameLevel}&age_group_id=${ageGroupId}`
    getData(url)
    .then(response =>{
      setBatchesData(response.result)
      setLoading(false)
    })
    .catch(error => {
      setLoading(false)
      console.log(error.message);
    });
  }

  const getFormattedTitle = (value) => {
    const formatted = value.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    return formatted
  };

  const columns = batchesData.length > 0 ? 
    [...Object.keys(batchesData[0]).filter(key => key !== 'venue_id').map(key => ({
        title: getFormattedTitle(key),  
        dataIndex: key,
        fixed: key == 'venue' ? 'left' : key.includes('(%)') ? 'right': '' ,
        key: key,
        align: key !== 'venue' && 'center',
        sorter: key !== 'venue' ? (a, b) => a[key] - b[key] : false,
        render: key === 'venue' ? 
                  (text, record) => {
                    // const cleanedText = text.replace(/Sporthood/i, "").trim();
                    const venuename = text.length > 30 ? `${text.slice(0, 30)}...` : text;
                    const level = gameLevel || 'All';
                    return(
                      <Tooltip title={record.venue}>
                        {page === 'summary' ? 
                          <Link to={`/batches/attendance-summary/${record.venue_id}/${level}`} className='venueTitle'>
                            {venuename}
                          </Link>
                          :
                          <Link to={`/batches/attendance/${record.venue_id}/${level}`} className='venueTitle'>
                            {venuename}
                          </Link>
                        }
                      </Tooltip>
                    )
                  }
                :
                key.includes('(%)') ?
                  text => {
                    return <PercentageBadge value={text}/>
                  }
                :
                  text => text
        })),
      {
        title: '',
        fixed:'right',
        dataIndex: 'venue_id',
        render: (value) => {
          const level = gameLevel || 'All';
          return(
            page === 'summary' ? 
              <Link to={`/batches/attendance-summary/${value}/${level}`} className='venueTitle'>
                <ArrowRightOutlined/>
              </Link>
              :
              <Link to={`/batches/attendance/${value}/${level}`} className='venueTitle'>
                <ArrowRightOutlined/>
              </Link>
            )
        }
      }
    ]
  : 
    [];

  return (
    <Spin spinning={loading} indicator={<Spinner />}>
      <Styled.MainContainer>

        <Styled.TopDiv>    
          <Styled.SelectorContainer>

            {cities.length > 1 &&
              <Styled.Selector>
                <span className='indicatorText'>City</span>
                <Select
                  mode="multiple"
                  className = 'mainSelector'
                  style={{width: 150}}
                  showSearch = {true}
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  filterOption={(input, option) => option.name.toLowerCase().includes(input.toLowerCase())}
                  onChange={handleCityChange}
                  value = {cityId}
                  bordered={false}
                >
                  <Option value="All" name="All"> All </Option>
                  {
                    cities.map(item=>(
                      <Option value={item.id} key={item.id} name = {item.name}> {item.name} </Option>    
                    ))
                  }
                </Select>
              </Styled.Selector>
            }
            {venuelist && venuelist.length > 0 &&
              <Styled.Selector> 
                <span className='indicatorText'>Venue</span>
                <Select
                  className = 'mainSelector'
                  style={{width: 300}}
                  showSearch = {true}
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  filterOption={(input, option) => option.name.toLowerCase().includes(input.toLowerCase())}
                  onChange={setSelectedVenueId}
                  value = {selectedVenueId}
                  bordered={false}
                >
                  <Option value="All" name="All"> All </Option>
                  {venuelist.map(item=>(
                    <Option value={item.id} key={item.id} name = {item.name}> {item.name} </Option>    
                    ))
                  }
                </Select>
              </Styled.Selector>
            }
            <Styled.Selector>
              <span className='indicatorText'>Program</span>
              <Select
                  className = 'mainSelector'
                  style={{width: 210}}
                  onChange={setGameType}
                  value = {gameType}
                  bordered={false}
                >
                  <Option value="8"> Football Academy </Option>
                  <Option value="10"> Badminton Academy </Option>
                  <Option value="65"> Swimming Academy </Option>
                  <Option value="44"> Tennis Academy </Option>

                </Select>
            </Styled.Selector>

            <Styled.Selector>
              <span className='indicatorText'>Skill Level</span>
              <Select
                  className = 'mainSelector'
                  style={{width: 210}}
                  onChange={setGameLevel}
                  value = {gameLevel}
                  bordered={false}
                >
                  <Option value=""> All </Option>
                  <Option value="Beginner"> Beginner </Option>
                  <Option value="Advanced"> Advanced </Option>
                  <Option value="Elite"> Elite </Option>
                </Select>
            </Styled.Selector>

            <Styled.Selector>
              <span className='indicatorText'>Age Group</span>
              <Select
                  className = 'mainSelector'
                  style={{width: 210}}
                  onChange={setageGroupId}
                  value = {ageGroupId}
                  bordered={false}
                > 
                  <Option value=""> All </Option>
                  {ageGroups.map((ageGroup,index)=>(
                      ageGroup.name != 'Adults' &&
                      <Option value={ageGroup.id}> {ageGroup.name} </Option>
                    ))
                  }
                </Select>
            </Styled.Selector>

          </Styled.SelectorContainer>
        </Styled.TopDiv>

        <Styled.Header>          
          <span>
            {page === 'summary' ? 
                'Attendance Summary (Active Customers Only)' 
              : 'Overall Attendance Summary'
            }
          </span>
        </Styled.Header>


        <Typography.Text type="primary" style={{ fontSize: 12, textAlign:'right' }}>
          * <b>Customers</b> count include only those assigned to a <b>batch</b> and consist of currently <b>active</b> and <b>payment due</b> customers within 14 days after expiry.
        </Typography.Text>

        <Table
          className="ant-table-thead table_container"
          rowKey="id"
          // tableLayout="fixed"
          columns={columns}
          dataSource={batchesData}
          pagination={false}
          scroll={{ x: 'max-content' }}
          
          summary={() => {
            const totalRow = {};
            const excludeKeys = ['venue', 'venue_id', 'last_week_percent', 'last_month_percent'];

            if (batchesData.length > 0) {
              Object.keys(batchesData[0]).forEach((key) => {
                if (!excludeKeys.includes(key)) {
                  const total = batchesData.reduce((sum, item) => {
                    const value = item[key];
                    return typeof value === 'number' ? sum + value : sum;
                  }, 0);
                  totalRow[key] = total;
                }
              });
              
              const percentKeys = ['last_month (%)', 'last_week (%)'];
              percentKeys.forEach((percentKey) => {
                const validValues = batchesData
                  .map((item) => {
                    const val = item[percentKey];
                    if (typeof val === 'string' && val.includes('%')) {
                      return parseFloat(val.replace('%', '').trim());
                    } else if (typeof val === 'number') {
                      return val;
                    }
                    return null;
                  })
                  .filter((v) => v !== null && !isNaN(v));

                  if (validValues.length > 0) {
                    const avg = validValues.reduce((a, b) => a + b, 0) / validValues.length;
                    totalRow[percentKey] = Math.round(avg) + '%';
                  }
              });
            }

            return (
              <Table.Summary.Row>
                {columns.map((col, index) => {
                  const key = col.dataIndex;
                  const value = totalRow[key];

                  return (
                    <Table.Summary.Cell
                      key={index}
                      align={col.align || 'left'}
                      index={index}
                      {...(col.fixed ? { fixed: col.fixed } : {})}
                    >
                      <b>
                        {index === 0 ? (
                          <strong>Total</strong>
                        ) : (
                          value !== undefined && value !== null ? value : ''
                        )}
                      </b>
                    </Table.Summary.Cell>
                  );
                })}
              </Table.Summary.Row>
            );
          }}
         />

      </Styled.MainContainer>
    </Spin>
  );
}

export default Attendance;



